<template>
  <div class="tan px_kcadd">
    <div class="px_add_con" style="width:1000px; margin-left:-500px;">
      <div class="h370 rdiv">
        <h3>选择试题</h3>
        <div class="add_kc_search">
          <input name="" type="button" class="btn_s" style="margin-left: 0;" @click="getList(filter)" /><input name="" type="text" class="text_put" v-model="filter.title" @keyup.13="getList(filter)" />
          <select v-model="filter.largeType" @change="getMiddleTypes(filter.largeType)" class="all_select">
            <option :value="''">(全部)大分类</option>
            <option v-for='item in largeTypes' :key="item.value" :value="item.value">{{item.label}}</option>
          </select>
          <select v-model="filter.middleType" @change="getList(filter)" class="all_select">
            <option :value="''">(全部)小分类</option>
            <option v-for='item in middleTypes' :key="item.middleType" :value="item.middleType">{{item.middleTypeLabel}}</option>
          </select>
        </div>
        <a href="javascript:void(0);" class="close" @click="$emit('close')"></a>
        <p><!--没有合适的课程？您可以<router-link to="/course/create">添加新试题</router-link>--></p>
        <div class="h295">
          <table width="960" border="0" cellspacing="0" cellpadding="0">
            <thead>
            <tr>
              <td width="15%"><input type='checkbox' :checked="isCheckedAll && data.length != 0" @click='checkedAll()'></td>
              <td width="46%">试题名称</td>
              <td width="15%">试题类型</td>
              <td width="25%">试题分类</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in data" :key="item.id">
              <td>
                <input type="checkbox" :value="item.id" :checked="selected.indexOf(item.id)>=0" @click='checkedOne(item)' />
              </td>
              <td>{{item.title}}</td>
              <td>{{item.questionTypeLabel}}</td>
              <td>{{item.largeTypeLabel}} - {{item.middleTypeLabel}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="clear"></div>
      <div class="modalPagination" v-if="data.length>0">
        <Paginate :click-handler="clickCallback" :page-count=pages
                  :container-class="'pagination-center'" :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                  :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                  :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                  :first-last-button=$global.paginationOptions.first_last_button
                  :active-class=$global.paginationOptions.active_class
                  :disabled-class=$global.paginationOptions.disabled_class
                  :first-button-text=$global.paginationOptions.first_button_text
                  :last-button-text=$global.paginationOptions.last_button_text
                  :prev-text=$global.paginationOptions.prev_text
                  :next-text=$global.paginationOptions.next_text></Paginate>
      </div>
      <div class="w240 wrap">
        <input name="" type="button" value="确定" class="all_btn" @click="setSelected"/>
        <input name="" type="button" value="取消" @click="$emit('close')" class="all_btn color_hui" />
      </div>
    </div>
  </div>
</template>

<script>
  import config from '@/config'
  import api from '@/api'
  import Paginate from 'vuejs-paginate'
  import Bus from '@/utils/bus'
  export default {
    components: { Paginate },
    mounted () {
      this.getList(this.filter)
      this.getLargeTypes()
      this.dealQList(this.qList)
    },
    computed: {},
    data () {
      return {
        data: [],
        pages: 5,
        selected: [],
        largeTypes: [],
        middleTypes: [],
        filter: {
          pageNo: 1,
          pageSize: this.$global.paginationOptions.page_num,
          type: '',
          largeType: '',
          level: '',
          middleType: ''
        },
        selectedQ: [],
        isCheckedAll: false
      }
    },
    props: ['qList'],
    methods: {
      clickCallback (pageNum)  {
        this.filter.pageNo = pageNum
        this.getList(this.filter)
      },
      getLargeTypes () {
        this.$api.post(this.$global.examApiPath, '/dict/get', {type: 'examLargeType'}, r => {
          this.largeTypes = r.data
        })
      },
      getMiddleTypes (largeType) {
        this.$api.post(this.$global.examApiPath, '/examTypeRel/search', {largeType: largeType, select: '1'}, r => {
          this.middleTypes = r.data
          this.getList(this.filter)
        })
      },
      checkedAllStatus (curData) {
        var cnt = 0
        if (curData && curData.length>0) {
          for (let i=0; i<curData.length; i++) {
            let idIndex = this.selected.indexOf(curData[i].id)
            if (idIndex >= 0) {
              cnt++
              continue
            } else {
              break
            }
          }
          if (cnt == this.data.length) {
            this.isCheckedAll = true
          } else {
            this.isCheckedAll = false
          }
        }
      },
      dealQList (arr) {
        for (let i=0; i<arr.length; i++) {
          this.selected.push(arr[i].id)
        }
        this.selectedQ = this.selectedQ.concat(arr)
      },
      getList (filter) {
        var that = this
        api.post(config.examApiPath, '/examQuestion/search', filter, function (r) {
          if (r.data && r.data.length>0) {
            that.data = r.data
          } else {
            that.data = []
          }
          that.checkedAllStatus(that.data)
          that.pages = Math.ceil(r.cntData / that.$global.paginationOptions.page_num)
        }, function (err) {
          console.log(err)
        })
      },
      checkedOne (item) {
        let idIndex = this.selected.indexOf(item.id)
        if (idIndex >= 0) {
          this.selected.splice(idIndex, 1)
          this.selectedQ.splice(idIndex, 1)
        } else {
          this.selected.push(item.id)
          this.selectedQ.push(item)
        }
        this.checkedAllStatus(this.data)
      },
      checkedAll () {
        this.isCheckedAll = !this.isCheckedAll
        if (this.isCheckedAll) {
          if (this.data.length>0) {
            for (let i = 0; i<this.data.length; i++) {
              let idIndex = this.selected.indexOf(this.data[i].id)
              if (idIndex < 0) {
                this.selected.push(this.data[i].id)
                this.selectedQ.push(this.data[i])
              }
            }
          }
        } else {
          for (let i=0; i<this.data.length; i++) {
            let idIndex = this.selected.indexOf(this.data[i].id)
            if (idIndex >= 0) {
              this.selected.splice(idIndex, 1)
              this.selectedQ.splice(idIndex, 1)
            }
          }
        }
      },
      setSelected () {
        for (let i=0; i<this.qList.length; i++) {
          let idIndex = this.selected.indexOf(this.qList[i].id)
          if (idIndex >= 0) {
            this.selectedQ[idIndex].score = this.qList[i].score
          }
        }
        Bus.$emit('selectedQuestions', this.selectedQ)
        this.$emit('close')
      }
    }
  }
</script>

<style scoped>
  input[type=checkbox] {
    opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// src/page/byl/org/examination_question/select.vue